import { HTMLAttributes } from 'react';
import styled from 'styled-components';

import { styles } from '../../styles';

export const ErrorHint = styled(
  ({
    show,
    ...props
  }: HTMLAttributes<HTMLDivElement> & {
    show: boolean;
  }) => <div {...props} />
)`
  ${styles.color.danger};
  font-size: 12px;
  margin-top: 2px;
  height: 0px;
  transition: all 0.3s;
  overflow: hidden;
  opacity: 0;
  flex-shrink: 0;
  ${(props) => (props.show ? `opacity: 1; height: 13px;` : '')};
`;
